<script setup lang="ts">
/**
 * Renderless helper that mirrors VeeValidate's slot-scoped `values` into
 * a ref the parent's setup() can read. Sibling of FormDirtyBridge.
 *
 * Use it when the dialog header or another out-of-form region needs to
 * react to a field — e.g. the item editor's header reflects the live
 * title, and the price chip reads the live counterpart price.
 *
 * Usage:
 *   <FormValuesBridge :values="values" @update="(v) => (liveValues = v)" />
 */
import { watch } from 'vue'

type Values = Record<string, unknown>

const props = defineProps<{ values: Values }>()
const emit = defineEmits<{ update: [values: Values] }>()

watch(
  () => props.values,
  (v) => emit('update', { ...v }),
  { immediate: true, deep: true },
)
</script>

<template>
  <span class="sr-only" aria-hidden="true" />
</template>
